// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/dust-and-sandstorms.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/dust-and-sandstorms/dust-and-sandstorms.js';

mount([g0]);
